<div class="password-input-container">
    <input [(ngModel)]="password" (ngModelChange)="passwordChange.emit(password)" [type]="hidePassword ? 'password' : 'text'"
           class="form-control uikit-input" name="password" autofocus placeholder="{{placeholder}}" [tabindex]="tabIndex" />
    <i class="eye-icon material-symbols-outlined" (click)="togglePassword()">{{hidePassword ? 'visibility_off' :
        'visibility'}}</i>
</div>
